import datadogLoggingServiceInstance from "./datadogLoggingService";

export default async function logError(message, attr) {
  try{
    datadogLoggingServiceInstance.logError(message, attr);
  } catch(error) {
    console.error(`Error logging to Datadog: ${error}`);
  }
}

function logInfo(message, attr) {
  try{
    datadogLoggingServiceInstance.logInfo(message, attr);
  } catch(error) {
    console.error(`Error logging to Datadog: ${error}`);
  }
}

export const logger = {
  error: logError,
  info: logInfo,
};
